// @flow

import type { SvgSprite } from 'SvgSprite';
import * as React from 'react';

/**
 * Takes a the output of svg-sprite-loader and returns a JSX element that can be drawn.
 * @param svgClass the className of the resulting element
 * @param useClass the className of the use element
 * @param svg Comes from svg-sprite-loader (the webpack loader).  The 'id' field is effectively a reference in SVG world
 *        that points to "the real SVG object" that the loader puts up toward the top of the page, and so href ends up
 *        being something like href="#the-svg-name" and the SVG can be found above in the DOM with the name
 *        "#the-svg-name" where 'the-svg-name' seems to be the extracted SVG filename (without the extension).
 * @param ariaHidden whether to hide it from the accessibility tree. Defaults to false.
 * @returns {JSX.Element}
 */

// Allows the optional specification of metadata for Cypress to use in tests
type Props = {
  dataCyTag?: string, // tag for locating svg
  dataCyStateTag?: string, // tag for SVGs that indicate state (like open/close icons)
};

export default (
  svgClass: string,
  useClass: string,
  svg: SvgSprite,
  ariaHidden: boolean = false
// eslint-disable-next-line no-undef
): React.AbstractComponent<*> => {
  const SvgImage = ({ dataCyTag, dataCyStateTag }: Props) => {
    return (
      <svg
        viewBox={svg.viewBox}
        className={svgClass}
        data-cy={dataCyTag}
        data-cy-state={dataCyStateTag}
        aria-hidden={ariaHidden}
      >
        <use x="0" y="0" className={useClass} href={'#' + svg.id} />
      </svg>
    );
  };
  return SvgImage;
};
